import { combineReducers, createStore, applyMiddleware } from 'redux';
import ReduxPromise from 'redux-promise';
import { composeWithDevToolsDevelopmentOnly } from '@redux-devtools/extension';
import loader from './loader';
import ADO from './ado';
import submitItemFormFields from './submitItemForm/fields';
import helpCall from './helpCall';
import item from './item';
import jewelryBox from './jewelryBox';
import logIn from './logIn';
import register from './register';
import session from './session';
import shippingLabel from './shippingLabel';
import pendingItem from './pendingItem';
import submissionProgress from './submissionProgress';
import conversationFlow from './chatBot/conversationFlow';
import paymentDetails from './payment_details';
import scheduleAppointment from './schedule_appointment';
import experiments from './experiments';
import footer from './footer';
import header from './header';
import tips from './tips';
import pendingJewelryBox from './pendingJewelryBox';
import myAccount from './myAccount';
import Homepage from './homepage';
import cuiVersion from './chatBot/cuiVersion';
import userFlow from './userFlow';
import preShipmentUi from "./personalize/preShipmentUi";
import itemsCount from './itemsCount';
import lastItem from './user';

const rootReducer = combineReducers({
    Loaders: loader,
    ADO: ADO,
    Experiments: experiments,
    Form: combineReducers({ Fields: submitItemFormFields }),
    Item: item,
    JewelryBox: jewelryBox,
    HelpCall: helpCall,
    LogIn: logIn,
    Register: register,
    Session: session,
    ShippingLabel: shippingLabel,
    PendingItem: pendingItem,
    submissionProgress: submissionProgress,
    ChatBot: combineReducers({ conversationFlow }),
    PaymentDetails: paymentDetails,
    ScheduleAppointment: scheduleAppointment,
    Footer: footer,
    Header: header,
    Tips: tips,
    PendingJewelryBox: pendingJewelryBox,
    MyAccount: myAccount,
    Homepage: Homepage,
    CuiVersion: cuiVersion,
    UserFlow: userFlow,
    Personalized: combineReducers({ preShipmentUi }),
    ItemsCount: itemsCount,
    LastItem: lastItem
});


const composeEnhancers = composeWithDevToolsDevelopmentOnly({
    serialize: true
});

const rootStore = composeEnhancers(applyMiddleware(ReduxPromise))(createStore)(rootReducer);


export default rootStore;
